<template>
  <div id="body" class="is-2column"
    :class="[
      {'is-preview-print': isPrintPreview},
      {'is-visible-login': group1.isFrontendLogin}
    ]">
  <!-- BackgroundImage / -->

    <div v-if="group1.isFrontendLogin" class="login-bar">
      <span>フロントエンドログイン中</span>
      <span class="ml12">事例ID: {{ group1.qaCode }}</span>
      <span class="ml12">追録号数: {{ group1.manualRecomentationDisp }} </span>
    </div>

    <PCPrint />

    <!-- div id="wrapper" -->

      <!-- content:start -->
      <div id="content">

        <!-- 設問詳細タイプが「2:QA」の場合 -->
        <template v-if="group1.type === 2">

          <iframe
            :src="group1.pdfURLStatic"
            :key="group1.pdfURLStatic"
            style="width:100%;"
            :style="{
            'height': 'calc(100vh)',
            'visibility':
            (!visibleMenu &&
            !common.systemError.show &&
            !common.notice.show)
            ? 'visible' : 'hidden'
            }"
            frameborder="0">
          </iframe>
        </template>

      <!-- /div -->
      <!-- content:end -->

      <!-- QA詳細は「TOP」は非表示 （iframe内のPDFのスクロールは制御できない）
        <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span> -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted, watch } from '@vue/composition-api'

import PCPrint from '@/components/pc/partial/PCPrint.vue'

import * as logicQADetail from '@/logic/qa/QADetailPdf'
import { isFromAdminSystem, escapeHTMLAndBr } from '@/util/common'

import PCQADetailTableOfContentsTreeItem from '@/components/pc/partial/qa/PCQADetailTableOfContentsTreeItem'

export default defineComponent({
  components: {
    PCPrint,
    PCQADetailTableOfContentsTreeItem
  },
  props: {
    // QA ID：URLで渡された値(/routes/index.jsで定義)
    qaId: {
      type: Number,
      required: true,
      default: 0
    },
    // ノート用 NOTE ID：URLで渡された値(/routes/index.jsで定義)
    noteId: {
      type: Number,
      required: false,
      default: 0
    },
    // ノート用 NOTE ROW ID：URLで渡された値(/routes/index.jsで定義)
    rowId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  setup (props, context) {
    const store = context.root.$store
    const { common } = store.state
    const router = context.root.$router

    // 外枠(青い部分)のpadding top
    const outerFramePaddingTop = 0
    // メインエリア(PDF or あらまし表示エリア)のpadding top
    const mainAreaPadingTop = 0

    /**
     * 本文PDFのRef
     * ref="refPDFViewerApp"を設定しているノード(コンポーネント)の参照
     */
    const refPDFViewerApp = ref()

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicQADetail.getGroup(props, context)

    const state = reactive({
    })

    const fitAutoPDFViewer = () => {
      context.refs.refPDFViewerApp.fitAutoViewer()
    }

    return {
      outerFramePaddingTop,
      mainAreaPadingTop,
      group1,
      state,
      refPDFViewerApp,
      fitAutoPDFViewer,
      isFromAdminSystem,
      escapeHTMLAndBr,
      common
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('qa/setReferrerObject', from)
    })
  }
})
</script>

<style lang="scss" scoped>
#wrapper:after {
  // top: -10px;
}
#content {
  display: flex;
  flex-wrap: nowrap;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
}
// フロントエンドログイン時
.login-bar {
  position: fixed;
  top: 0;
  height: 50px;
  box-sizing: border-box;
  z-index: 10;
  width: 100%;
  background-color: $color-hdg;
  color: #fff;
  font-size: 1.8rem;
  padding: 12px 52px 12px 12px;
}
.is-visible-login {
  #bg-image ,
  .menu-bar ,
  #header ,
  .popup-wrapper {
    top: 50px;
  }
  #wrapper {
    padding-top: 136px;
  }
  #bg-image {
  top: 50px;
  }
  .is-hidden-header {
    #wrapper {
      padding-top: 66px;
    }
  }
}

</style>
